import React from 'react';
import { useNavigate } from 'react-router-dom';

const PageHeader = ({
  title,
  icon = 'bi-file-text',
  onClose,
  showCloseButton = true,
  closeRoute = '/home',
  closeState = null,
  onLogout,
}) => {
  const navigate = useNavigate();

  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      if (closeState) {
        navigate(closeRoute, { state: closeState });
      } else {
        navigate(closeRoute);
      }
    }
  };

  return (
    <div
      className="card-header text-white small"
      style={{
        background:
          'linear-gradient(0deg, rgb(7, 99, 7) 0%, rgb(7, 59, 43) 100%)',
        padding: '0.2rem 0.75rem',
        borderTopLeftRadius: '0.5rem',
        borderTopRightRadius: '0.5rem',
      }}
    >
      <div className="d-flex align-items-center justify-content-between">
        <h6 className="mb-0" style={{ fontSize: '0.80rem', lineHeight: 1 }}>
          <i className={`bi ${icon} me-2`}></i>
          {title}
        </h6>
        <div className="d-flex align-items-center gap-2">
          {onLogout && title === 'Entidades Vinculadas ao Usuário' && (
            <button
              className="btn btn-link btn-sm text-white p-0 mb-0"
              onClick={onLogout}
              title="Sair do sistema"
              style={{ fontSize: '1rem' }}
            >
              <i className="bi bi-power" />
            </button>
          )}
          {showCloseButton && title !== 'Entidades Vinculadas ao Usuário' && (
            <button
              className="btn btn-link text-white p-0 mb-0"
              onClick={handleClose}
              title="Fechar"
              style={{ fontSize: '1rem', textDecoration: 'none' }}
            >
              <i className="bi bi-x-lg"></i>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PageHeader;